import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';
import { FaOm, FaInstagram, FaLinkedin} from 'react-icons/fa';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-orange-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-orange-400 to-red-400 rounded-full flex items-center justify-center">
                <FaOm className="text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold">Anant Aaradhya</h3>
                <p className="text-xs text-orange-200">{t('divineConnection')}</p>
              </div>
            </div>
            <p className="text-orange-200 mb-4">
              {t('footerDescription')}
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4">{t('quickLinks')}</h4>
            <ul className="space-y-2 text-orange-200">
              <li>
                <Link to="/live" className="hover:text-white transition-colors">
                  {t('liveDarshan')}
                </Link>
              </li>
              <li>
                <Link to="/temples" className="hover:text-white transition-colors">
                  {t('temples')}
                </Link>
              </li>
              <li>
                <Link to="/panchang" className="hover:text-white transition-colors">
                  {t('panchang')}
                </Link>
              </li>
              <li>
                <Link to="/articles" className="hover:text-white transition-colors">
                  {t('library')}
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Social Media */}
          <div>
            <h4 className="font-bold mb-4">{t('followUs')}</h4>
            <div className="flex space-x-4">
              {/* <button 
                className="w-10 h-10 bg-orange-700 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors"
                aria-label="Facebook"
                onClick={() => window.open('https://facebook.com', '_blank')}
              >
                <FaFacebookF />
              </button> */}
              <button 
                className="w-10 h-10 bg-orange-700 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors"
                aria-label="Instagram"
                onClick={() => window.open('https://www.instagram.com/ananta_aradhya?igsh=aHJ4ajdqaXc3NHV6&utm_source=qr', '_blank')}
              >
                <FaInstagram />
              </button>
              <button 
                className="w-10 h-10 bg-orange-700 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors"
                aria-label="YouTube"
                onClick={() => window.open('https://www.linkedin.com/in/anant-aradhya-573561384/', '_blank')}
              >
                <FaLinkedin />
              </button>
            </div>
          </div>
        </div>
        
        <div className="border-t border-orange-700 mt-8 pt-8 text-center text-orange-200">
          <p>&copy; 2024 Anant Aaradhya. {t('allRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
